import { render, staticRenderFns } from "./PrizeDialog.vue?vue&type=template&id=5377105c&scoped=true&"
import script from "./PrizeDialog.vue?vue&type=script&lang=js&"
export * from "./PrizeDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrizeDialog.vue?vue&type=style&index=0&id=5377105c&scoped=true&lang=scss&"
import style1 from "./PrizeDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5377105c",
  null
  
)

export default component.exports